import * as MapViews from './components/MapComposites';
import * as WebViews from './components/WebComposites';
var ReactArcGIS = {
    Map: MapViews.Map,
    Scene: MapViews.Scene,
    WebMap: WebViews.WebMap,
    WebScene: WebViews.WebScene
};
export default ReactArcGIS;
export var WebMap = ReactArcGIS.WebMap;
export var WebScene = ReactArcGIS.WebScene;
export var Map = ReactArcGIS.Map;
export var Scene = ReactArcGIS.Scene;
//# sourceMappingURL=index.js.map